module.exports = __webpack_public_path__ + "static/media/icons_Les Essentiels - fibromyalgie.b69fe28c.svg";